


























































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import CustomExtensionDeleteModal from "@/components/customExtensions/modals/CustomExtensionDeleteModal.vue";
import CustomExtensionInfoModal from "@/components/customExtensions/modals/CustomExtensionInfoModal.vue";
import CustomExtensionPreviewModal from "@/components/customExtensions/modals/CustomExtensionPreviewModal.vue";
// service methods
import { getExtensionsByAccess } from "@/services/customExtensions/customExtensionService";
// types
import { CustomExtension } from "@/services/customExtensions/types";
import { customExtensionsFields } from "@/components/customExtensions/customExtensionFields";

@Component({
    components: { CustomExtensionDeleteModal, CustomExtensionInfoModal, CustomExtensionPreviewModal }
})
export default class CustomExtensions extends Vue {
    // local state
    customExtensions = [] as Array<CustomExtension>;
    searchQuery = "";
    isBusy = false;
    fields = customExtensionsFields;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    updateExtension(extension: CustomExtension) {
        return {
            name: "updateCustomExtension",
            params: { customExtensionId: extension.id }
        };
    }

    fetchData() {
        getExtensionsByAccess().then(response => {
            this.customExtensions = response;
        });
    }

    get filteredData(): Array<CustomExtension> {
        return this.customExtensions.filter(
            x =>
                this.searchQuery.length === 0 ||
                x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }

    info(id: string) {
        (this.$refs.customExtensionInfoModal as any).open(id);
    }

    preview(extension: CustomExtension) {
        (this.$refs.customExtensionPreviewModal as any).open(extension);
    }

    deleteCustomExtension(id: string, name: string) {
        (this.$refs.customExtensionDeleteModal as any)
            .open(id, name);
    }
}
